module.exports = __webpack_public_path__ + "static/media/ScreenShot_Genejs_Table_2020-06-25.30319b59.png";